import axios from 'axios';
import messageInfo from '@/services/general/messageInformation';
import router from '../router';
import i18n from '../i18n/index';
import store from '../store/store';

const HTTP = axios.create();

const BASE_URL_APIGOUVFR = 'https://geo.api.gouv.fr/';

HTTP.interceptors.request.use((request) => {
  request.headers = {
    'Content-Type': 'application/json',
  };
  if (request.url.indexOf('http') === -1) {
    // Do something before request is sent
    request.url = BASE_URL_APIGOUVFR + request.url;
  }
  return request;
});

HTTP.interceptors.response.use((response) => {
  return response;
}, (error) => {
  if (error.response.status === 401) {
    const site = store.getters['user/site'];
    router.push({ name: 'connexion', query: { site: site } });
    messageInfo(i18n.t('general.inactiveSession'));
  }
  throw error;
});

export default HTTP;
